<template>
    <div
        id="lt-yantr"
        class="rate-table yantr-tracking rate-table-auto-refinance">
        <div class="container-width">
            <div class="rate-table-filter">
                <div class="top-section">
                    <h3>Auto Refinance Rates in <span>{{ GeoLocationData.city + ', ' + GeoLocationData.state }}</span></h3>
                    <div class="adv-disclosure-block">
                        <template v-if="ShowHdltgp">
                            <button
                                id="ltPaidBtn"
                                class="lt-paid a11y-modal-trigger"
                                data-target="ltPaid">
                                {{ ltPaidTitle }}
                            </button>
                            <div class="dsk-lt-paid">
                                <tooltip-view
                                    :label="ltPaidTitle"
                                    :show-on-over="ShowOnOver"
                                    :popper-content="ltPaidDescription"
                                    reference-element="open me"
                                />
                            </div>
                        </template>
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="disclosureText"
                            :disclosure-tokens="disclosureTokens"
                            :open-disclosure-modal="openDisclosureModal"
                        />
                    </div>
                </div>
                <div class="main-section">
                    <input
                        id="show-filter"
                        type="radio"
                        name="filter"
                    />
                    <label
                        for="show-filter"
                        class="btn btn-orange show-filter"><span class="lt4-Funnel"></span>Customize Rates</label>
                    <input
                        id="hide-filter"
                        type="radio"
                        name="filter"
                    />
                    <label
                        for="hide-filter"
                        class="hide-filter">×</label>
                    <ul class="filter-inputs">
                        <li>
                            <number-input
                                v-model="LoanAmount"
                                :label="labelLoanAmount"
                                :tooltip-link="LoanAmountTooltip"
                                inputmode="decimal"
                            />
                        </li>
                        <li>
                            <drop-down
                                v-model="CreditScore"
                                :label="labelCreditScore"
                                :options="CreditScoreList"
                                :tooltip-link="CreditScoreTooltip"
                            />
                            <a
                                href="/redirect/offers?id=calc-fcs"
                                class="font-sm"
                                target="_blank">Get your credit score</a>
                        </li>
                        <li>
                            <geo-by-zip-input
                                ref="geoByZip"
                                v-model="GeoLocation"
                                :label="labelZipCode"
                                :zip-code="GeoLocationData.zipCode"
                                @showHideLocation="showHideLocation()"
                                @input="getOffersResponse()"
                            />
                        </li>
                        <li>
                            <button
                                class="btn btn-orange"
                                type="submit"
                                @click="getOffersResponse()">
                                {{ updateRatesButtonText }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="monthly-result">
                <div
                    v-if="!IsDataLoaded"
                    class="spinner-block">
                    <spinner />
                    <span>Searching for Offers...</span>
                </div>
                <div v-else-if="!IsEmptyData">
                    <div
                        v-for="(offers, index) in GroupedOffers"
                        :key="index">
                        <auto-refinance-rates-info
                            v-if="offers"
                            :offers="offers"
                            :lender-review-rating-details="LenderReviewRatingDetails"
                            :lender-offer-details="LenderOfferDetails"
                            :field-edited="FieldEdited"
                        />
                    </div>
                </div>
                <div
                    v-else-if="IsEmptyData || IsEmptyData === undefined"
                    class="no-offer-found">
                    No Offers Found.
                </div>
            </div>
        </div>
        <a11y-modal
            v-if="ShowHdltgp"
            id="ltPaid">
            <template #h4>
                {{ ltPaidTitle }}
            </template>
            <div slot="body">
                <div class="description">
                    <p> {{ ltPaidDescription }} </p>
                </div>
            </div>
        </a11y-modal>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import GeoByZipInput from '~/components/geo-by-zip-input.vue';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import CreditScoreList from '~/constants/credit-score-list';
    import AutoRefinanceRatesInfo from '~/components/auto-refinance-rates-info.vue';
    import autoRateTableService from '~/services/auto-rate-table-service';
    import Spinner from '~/components/spinner.vue';
    import RateTableMixin from '~/mixin/rate-table';
    import getLenderBadges from '~/services/lender-badge';
    import AutoRateTableMixin from '~/mixin/auto-rate-table-mixin';
    import a11yModal from '~/helpers/a11y-modal';
    import A11yModal from '~/components/a11y-modal.vue';
    import TooltipView from '~/components/tooltip-view.vue';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        components: {
            AdvertisingDisclosures,
            GeoByZipInput,
            NumberInput,
            DropDown,
            AutoRefinanceRatesInfo,
            Spinner,
            A11yModal,
            TooltipView,
        },
        mixins: [RateTableMixin, AutoRateTableMixin, RateTableInfo],
        props: {
            disclosureText: {
                default: 'Disclosures',
            },
            disclosureTokens: {
                default: '00001,00057,00058,00059,00099,101',
            },
            zipCode: {
                default: '28277',
            },
            showLocation: {
                default: true,
            },
            labelLoanAmount: {
                default: 'Loan Amount',
            },
            loanAmount: {
                default: '20000',
            },
            updateRatesButtonText: {
                default: 'Refresh Rates',
            },
            loanAmountTooltip: {
                default: DefaultTooltip.LoanAmount,
            },
            labelCreditScore: {
                default: 'Est. Credit Score',
            },
            creditScore: {
                default: 'Excellent720OrMore',
            },
            creditScoreTooltip: {
                default: DefaultTooltip.CreditScore,
            },
            destinationButtonText: {
                default: 'See if you qualify',
            },
            destinationLinkOrId: {
                default: 'wp-auto',
            },
            openDisclosureModal: {
                default: true,
            },
            autoLoanType: {
                default: 'Refinance',
            },
            groupedOffers: {
                default() {
                    return {};
                },
            },
            loanTerms: {
                default: '',
            },
            ltPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            ltPaidDescription: {
                default: 'LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.',
            },
            showQuestionMark: {
                default: false,
            },
            showOnOver: {
                default: true,
            },
            labelZipCode: {
                default: 'Zip Code',
            },
            hideHdltgp: {
                default: false,
            },
        },
        data() {
            return {
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                ShowLocation: this.showLocation,
                GeoLocation: {
                    ZipCode: this.zipCode,
                },
                LoanAmount: this.loanAmount,
                CreditScore: this.creditScore,
                LoanAmountTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanAmountTooltip,
                CreditScoreTooltip: parseInt(this.hideTooltip, 10) ? '' : this.creditScoreTooltip,
                CreditScoreList: CreditScoreList.ratetableauto,
                DestinationButtonText: this.destinationButtonText,
                DestinationLinkOrId: this.destinationLinkOrId,
                GroupedOffers: this.groupedOffers,
                IsDataLoaded: false,
                IsEmptyData: false,
                PageLoadCounter: 0,
                LoanTermArray: [],
                Offers: [],
                Lenders: [],
                QuotesId: '',
                OffersList: {},
                showModal: false,
                ShowQuestionMark: this.showQuestionMark,
                ShowOnOver: this.showOnOver,
                ShowHdltgp: !this.hideHdltgp,
                FieldEdited: 'no',
            };
        },
        computed: {
            GeoLocationData() {
                return this.GeoLocation;
            },
        },
        watch: {
            LoanAmount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
            CreditScore(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
        },
        mounted() {
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
            if (this.loanTerms) this.LoanTermArray = this.loanTerms.split(',');
        },
        methods: {
            closeModal() {
                this.showModal = false;
            },
            tooltipContent() {
                return '<div class="popup-content">LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.</div>';
            },
            showHideLocation() {
                this.ShowLocation = !this.ShowLocation;
            },
            getOffersResponse() {
                const creditScoreRegex = /([A-Z]|[a-z])\w+/g;
                const optionalParams = {};
                let creditScoreValue = '';
                let creditScoreType;
                let loanAmount;

                this.IsEmptyData = true;
                this.IsDataLoaded = false;
                if (this.GeoLocation.state) optionalParams.state = this.GeoLocation.state.trim();
                if (this.loanTerms.length > 0) optionalParams.loanTerms = this.loanTerms.trim();

                this.CreditScoreList.forEach((score) => {
                    if (this.CreditScore === score.value) creditScoreValue = score.text;
                });

                const match = creditScoreRegex.exec(creditScoreValue);
                if (match && match[0]) {
                    creditScoreType = match[0].toLowerCase();
                    if (creditScoreType === 'excellent') {
                        optionalParams.creditScoreMin = 720;
                        optionalParams.creditScoreMax = 800;
                    } else if (creditScoreType === 'good') {
                        optionalParams.creditScoreMin = 680;
                        optionalParams.creditScoreMax = 719;
                    } else if (creditScoreType === 'fair') {
                        optionalParams.creditScoreMin = 640;
                        optionalParams.creditScoreMax = 679;
                    } else if (creditScoreType === 'poor') {
                        optionalParams.creditScoreMax = 639;
                    }
                }
                loanAmount = Accounting.unformat(this.LoanAmount);
                if (loanAmount <= 30000) {
                    optionalParams.loanAmountMin = 1;
                    optionalParams.loanAmountMax = 30000;
                } else if (loanAmount > 30000 && loanAmount <= 75000) {
                    optionalParams.loanAmountMin = 30001;
                    optionalParams.loanAmountMax = 75000;
                } else if (loanAmount > 75000) {
                    optionalParams.loanAmountMin = 75000;
                    optionalParams.loanAmountMax = 300000;
                }
                autoRateTableService(this.autoLoanType, '', optionalParams, this.updateOffersDetail);
            },
            updateOffersDetail(offers) {
                const badges = {};
                this.OffersList = offers;
                const lenderIDs = this.refreshOffers(offers, badges);
                this.getLenderDetailsList(offers);
                if (lenderIDs && lenderIDs.length > 0) {
                    getLenderBadges(lenderIDs, this.updateBadges);
                }
            },
            refreshOffers(offers, badges) {
                const offerDetailList = {};
                const lenderIDs = [];
                this.IsDataLoaded = true;
                if (offers && offers.length > 0) {
                    this.IsEmptyData = false;
                    offers.forEach((offer) => {
                        if (lenderIDs.indexOf(offer.LenderId) < 0) {
                            lenderIDs.push(offer.LenderId);
                        }
                        if (badges && Object.keys(badges).length > 0) {
                            offer.BadgesDetail = badges[offer.LenderId];
                        }
                        if (offer && (this.loanTerms.trim().length === 0 || this.LoanTermArray.indexOf(offer.AmortizationTermMonths.toString()) >= 0)) {
                            offer.IsToggleLinkVisible = true;
                            offer.IsLenderActive = false;
                            const monthlyApr = offer.Apr / 100.00 / 12.00;
                            const monthlyPayment = Math.round(monthlyApr * Accounting.unformat(this.LoanAmount) / (1 - (1 + monthlyApr) ** -offer.AmortizationTermMonths));
                            offer.calculatedMonthlyPayment = monthlyPayment;

                            const hasTermMonthsProperty = Object.hasOwn(offerDetailList, offer.AmortizationTermMonths);
                            if (hasTermMonthsProperty) {
                                if (offerDetailList[offer.AmortizationTermMonths].length < 5) {
                                    offerDetailList[offer.AmortizationTermMonths].push(offer);
                                    if (offerDetailList[offer.AmortizationTermMonths].lowAPROffer.Apr > offer.Apr) {
                                        offerDetailList[offer.AmortizationTermMonths].lowAPROffer = offer;
                                    }
                                }
                            } else {
                                offerDetailList[offer.AmortizationTermMonths] = [offer];
                                offerDetailList[offer.AmortizationTermMonths].lowAPROffer = offer;
                            }
                        }
                    });
                } else {
                    this.IsEmptyData = true;
                    this.fieldEdited = this.FieldEdited;
                    this.rateTableViewedInfo(this);
                }
                if (offerDetailList && Object.keys(offerDetailList).length > 0) {
                    const activeLoanTerm = Object.keys(offerDetailList).indexOf('60') >= 0 ? 60 : Object.keys(offerDetailList)[0];
                    offerDetailList[activeLoanTerm].IsActive = true;
                }
                this.GroupedOffers = offerDetailList;
                return lenderIDs;
            },
            updateBadges(badges) {
                this.refreshOffers(this.OffersList, badges);
            },
            updateOffersResponse(response) {
                this.Offers = response ? response.Offers : null;
                this.Lenders = response.Lenders;
                this.QuotesId = response.QuotesId;
                this.IsDataLoaded = true;
                if (this.Offers.length > 0 && !this.isResultRefined && this.PageLoadCounter === 0) {
                    this.PageLoadCounter += 1;
                }
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
<style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
